import React, { useRef } from "react";

export const InputTutorial = () => {
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);

  const getPreviousRef = (currentRef) => {
    switch (currentRef) {
      case ref4:
        return ref3;
      case ref3:
        return ref2;
      case ref2:
        return ref1;
      default:
        return null;
    }
  };

  const handleInput = (currentRef, nextRef) => {
    currentRef.current.focus();
    const value = currentRef.current.value;

    if (value === "") {
      const previousRef = getPreviousRef(currentRef);
      if (previousRef) {
        previousRef.current.focus();
      }
    } else if (nextRef) {
      nextRef.current.focus();
    }
  };

  return (
    <div className="w-full text-3xl">
      <h1>Please verify your email</h1>
      <form className="w-full">
        <div className="w-full flex items-center justify-center gap-2 h-screen ">
          <input
            className="border border-red-500 w-1/6 h-20 text-center"
            type={"number"}
            maxLength={1}
            id="input1"
            ref={ref1}
            onChange={() => handleInput(ref1, ref2)}
          />
          <input
            className="border border-red-500 w-1/6 h-20 text-center"
            type={"number"}
            maxLength={1}
            id="input2"
            ref={ref2}
            onChange={() => handleInput(ref2, ref3)}
          />
          <input
            className="border border-red-500 w-1/6 h-20 text-center"
            type={"number"}
            maxLength={1}
            id="input3"
            ref={ref3}
            onChange={() => handleInput(ref3, ref4)}
          />
          <input
            className="border border-red-500 w-1/6 h-20 text-center"
            type={"number"}
            maxLength={1}
            id="input4"
            ref={ref4}
            onChange={() => handleInput(ref4, ref4)}
          />
        </div>
      </form>
    </div>
  );
};
